import { useCallback, useEffect, useState } from 'react';
import { produce } from 'immer';
import Gradient from "javascript-color-gradient";
import { useTheme } from 'services/theme';
import { dotDiametr, coeffOffset } from '../initials';

export const useCoeffsArray = ({
    height,
    coeffs,
    dotsArr,
}) => {
    const [coeffsArray, setCoeffsArray] = useState([]);

    const theme = useTheme();

    useEffect(() => {
        if (dotsArr.length !== height) {
            return;
        }

        const coefsCount = height + 1;
        const colorsCount = Math.ceil(coefsCount / 2);

        const colors = new Gradient()
            .setColorGradient(theme['start-coef-color'], theme['end-coef-color'])
            .setMidpoint(colorsCount)
            .getColors();

        let coeffState = [];

        for (let i = 0; i < colorsCount; i++) {
            coeffState.push({
                x: dotsArr[height - 1][i].dotX + dotDiametr,
                y: dotsArr[height - 1][0].dotY + coeffOffset,
                color: colors[i],
                textColor: i < 2 ? 'white' : 'black',
                isHighlighted: false,
                value: coeffs[i]?.toFixed(2),
            });

            const addSecondPoint = i !== height / 2 || height % 2 === 0;

            if (addSecondPoint) {
                const j = height - i;

                coeffState.push({
                    x: dotsArr[height - 1][j].dotX + dotDiametr,
                    y: dotsArr[height - 1][0].dotY + dotDiametr * 3,
                    color: colors[i],
                    textColor: i < 2 ? 'white' : 'black',
                    isHighlighted: false,
                    value: coeffs[j]?.toFixed(2),
                });
            }
        }

        setCoeffsArray(coeffState);
    }, [height, dotsArr, coeffs, theme]);

    const highlightCoeff = useCallback((index, value) => {
        setCoeffsArray((prev) => produce(prev, (draft) => {
            draft[index].isHighlighted = value;
        }))
    }, [setCoeffsArray]);

    return {
        coeffsArray,
        highlightCoeff,
    };
};
